import React from 'react'

const Fallback = ({ items }) =>
  items.map(({ label }, i) => <span key={`${label}-${i}`}>{label}</span>)

Fallback.defaultProps = {
  items: []
}

export default React.memo(Fallback)
